import { AuthTokenResponse } from '../../auth'

export const TELECONSULTA_AUTH_KEY = 'kt-auth-teleconsulta'

export const getTeleAuth = (): AuthTokenResponse | undefined => {
  const lsValue = localStorage.getItem(TELECONSULTA_AUTH_KEY)
  if (!lsValue) return
  try {
    return JSON.parse(lsValue) as AuthTokenResponse
  } catch (err) {
    console.error('TELECONSULTA AUTH PARSE ERROR', err)
  }
}

export const setTeleAuth = (auth: AuthTokenResponse) => {
  try {
    localStorage.setItem(TELECONSULTA_AUTH_KEY, JSON.stringify(auth))
  } catch (err) {
    console.error('TELECONSULTA AUTH SAVE ERROR', err)
  }
}

export const removeTeleAuth = () => {
  try {
    localStorage.removeItem(TELECONSULTA_AUTH_KEY)
  } catch (err) {
    console.error('TELECONSULTA AUTH REMOVE ERROR', err)
  }
}
